import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import '../Style.css';

// Open/close state shared by every UDI list field that edits its rows in a popup
export const useUDIRowPopup = (resetForm) => {
    const [isOpen, setIsOpen] = useState(false);

    return {
        isOpen,
        openAdd: () => { resetForm(); setIsOpen(true); },
        openEdit: () => setIsOpen(true),
        close: () => { resetForm(); setIsOpen(false); },
    };
};

export const UDIPopupField = ({ label, children }) => (
    <div className="udi-row-popup-field">
        <label>{label}</label>
        {children}
    </div>
);

export const UDIAddRowButton = ({ label, onClick }) => (
    <input type="button" className="udiActionButton" value={label} onClick={onClick} style={{ marginTop: '10px' }} />
);

const UDIRowPopup = ({ isOpen, title, onClose, onSave, saveLabel = "Save", saveDisabled = false, width = "480px", children }) => {

    useEffect(() => {
        if (!isOpen)
            return;
        const onKeyDown = (e) => { if (e.key === "Escape") onClose(); };
        document.addEventListener("keydown", onKeyDown);
        return () => document.removeEventListener("keydown", onKeyDown);
    }, [isOpen, onClose]);

    if (!isOpen)
        return null;

    return createPortal(
        <div style={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", background: "rgba(0,0,0,0.35)", zIndex: 1100, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <div role="dialog" aria-label={title} style={{ background: "white", borderRadius: "15px", boxShadow: "0 2px 8px rgba(0,0,0,0.15)", padding: "25px", width, maxWidth: "90vw", maxHeight: "90vh", display: "flex", flexDirection: "column" }}>

                <div style={{ display: "flex", flexDirection: "row" }}>
                    <div style={{ flex: 1 }}>
                        <h3>{title}</h3>
                    </div>
                    <div>
                        <button type="button" className="close-button" aria-label="Close" onClick={onClose}>
                            <i className="fas fa-times"></i>
                        </button>
                    </div>
                </div>

                <div className="udi-row-popup-body">
                    {children}
                </div>

                <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "15px" }}>
                    <button type="button" className="action-button cancel-button" onClick={onClose}>Cancel</button>
                    <button type="button" className="action-button save-button" onClick={onSave} disabled={saveDisabled}
                        style={saveDisabled ? { opacity: 0.6, cursor: "not-allowed" } : null}>
                        {saveLabel}
                    </button>
                </div>

            </div>
        </div>,
        document.body
    );
};

export default UDIRowPopup;
